import { Phone, MessageCircle, Mail } from 'lucide-react';

/**
 * ContactActions — the three mandatory contact buttons on every product
 * detail page: Call / WhatsApp / Email. Values come from the *store* object
 * (contact_phone / contact_whatsapp / contact_email) — NOT from the owner.
 */
export default function ContactActions({ store = {}, itemTitle = '', locale = 'ar', variant = 'primary' }) {
  const isAr = locale === 'ar';
  const clean = (p) => (p || '').replace(/[^0-9]/g, '');
  const msg = encodeURIComponent(
    isAr ? `مرحباً، أنا مهتم بـ "${itemTitle}"` : `Hi, I'm interested in "${itemTitle}"`,
  );
  const subj = encodeURIComponent(itemTitle || (isAr ? 'استفسار' : 'Inquiry'));

  const btnBase =
    'flex items-center justify-center gap-2 h-12 rounded-xl font-semibold text-sm shadow-sm active:scale-[0.98] transition-all duration-150';

  const compact = variant === 'compact';

  return (
    <div className={`grid grid-cols-3 gap-2 ${compact ? 'mt-2' : 'mt-4'} w-full`} data-testid="contact-actions">
      <a
        href={store.contact_phone ? `tel:${store.contact_phone}` : undefined}
        onClick={(e) => { if (!store.contact_phone) e.preventDefault(); }}
        className={`${btnBase} ${store.contact_phone
          ? 'bg-[#1E9BD9] text-white hover:bg-[#0284C7]'
          : 'bg-slate-200 text-slate-500 cursor-not-allowed dark:bg-white/10 dark:text-white/40'}`}
        data-testid="btn-call"
      >
        <Phone className="h-4 w-4" />
        <span>{isAr ? 'اتصل' : 'Call'}</span>
      </a>
      <a
        href={store.contact_whatsapp ? `https://wa.me/${clean(store.contact_whatsapp)}?text=${msg}` : undefined}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => { if (!store.contact_whatsapp) e.preventDefault(); }}
        className={`${btnBase} ${store.contact_whatsapp
          ? 'bg-green-600 text-white hover:bg-green-700'
          : 'bg-slate-200 text-slate-500 cursor-not-allowed dark:bg-white/10 dark:text-white/40'}`}
        data-testid="btn-whatsapp"
      >
        <MessageCircle className="h-4 w-4" />
        <span>{isAr ? 'واتساب' : 'WhatsApp'}</span>
      </a>
      <a
        href={store.contact_email ? `mailto:${store.contact_email}?subject=${subj}` : undefined}
        onClick={(e) => { if (!store.contact_email) e.preventDefault(); }}
        className={`${btnBase} ${store.contact_email
          ? 'bg-slate-800 text-white hover:bg-slate-900 dark:bg-white/10 dark:hover:bg-white/20'
          : 'bg-slate-200 text-slate-500 cursor-not-allowed dark:bg-white/10 dark:text-white/40'}`}
        data-testid="btn-email"
      >
        <Mail className="h-4 w-4" />
        <span>{isAr ? 'بريد' : 'Email'}</span>
      </a>
    </div>
  );
}
